import {AUTHENTICATED, AUTHENTICATION_ERROR, UNAUTHENTICATED} from '../actions/auth_actions';
import {CreateReducer} from '../utils/create_reducer';

const initState = {
    authenticated: false,
    error: undefined,
    userRole: null,
    userName: null,
    success:false
};

const authReducer = CreateReducer(initState, {
    [AUTHENTICATED](state, action) {
        if (action.payload !== undefined) {
            return {
                ...state,
                authenticated: true,
                userRole: action.payload.userRole,
                userName: action.payload.userName
            };
        }
        return {...state, authenticated: true, userRole: action.userRole, userName: action.userName};
    },
    [UNAUTHENTICATED](state, action) {
        if(action.payload){
            return {...initState, error: action.payload.error,success:false};
        }
        return {...initState, error: action.payload};
    },
    [AUTHENTICATION_ERROR](state, action) {
        return {...state, error: action.payload};
    }
});

export default authReducer;


// WEBPACK FOOTER //
// ./src/reducers/auth_reducer.js